import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Header, Icon, Modal, List, Loader, Divider } from "semantic-ui-react";
import AddFileNameIdentifier from "../AddFileNameIdentifier";
// import ProcessedNameExamples from "./ProcessedNameExamples";

function ProcessConfirmationModal({ data, open, setOpen, onSuccess, dataForOnSuccess }) {
  const { t } = useTranslation("common");
  const [newDataForOnSuccess, setNewDataForOnSuccess] = useState([]);
  const [canSendForProcessing, setCanSendForProcessing] = useState(false);
  const [readyForRender, setReadyForRender] = useState(false);
  const checkValidCharacters = (fileName) => {
    const nonValidCharacters = new RegExp(/[^a-zA-Z0-9_.-]/g);
    return fileName.replace(nonValidCharacters, "");
  };
  const newFileName = (file, fileNameIdentifier) =>
    `${
      file.campaign.orderlineID !== "" ? file.campaign.orderlineID + "_" : file.campaign.orderlineID
    }${checkValidCharacters(file.campaign.advertiser)}_${fileNameIdentifier + "_"}`;

  const addFileNameIdentifier = (fileId, fileNameIdentifier) => {
    const file = newDataForOnSuccess.find((file) => file.processId === fileId);
    if (!file) return;

    const updatedItem = {
      ...file,
      processedName: newFileName(file, fileNameIdentifier).replace(/\s/g, ""),
      fileNameIdentifier,
    };

    const updatedArray = newDataForOnSuccess.map((file) =>
      file.processId === fileId ? updatedItem : file
    );
    setNewDataForOnSuccess(updatedArray);
  };

  const generateUuid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  useEffect(() => {
    const checkFileNameIdentifiers = newDataForOnSuccess.filter(
      (file) => file.fileNameIdentifier !== ""
    );
    setCanSendForProcessing(checkFileNameIdentifiers.length === newDataForOnSuccess.length);
  }, [newDataForOnSuccess]);

  useEffect(() => {
    const newData = dataForOnSuccess.map((file, i) => {
      const count = i + 1;
      const stringIndex = String(count);
      /** Generate default id for file. Id length must be minimum 4 characters.
       *  Add 0's to file identifier until 4 characters is reached. */
      const newId =
        stringIndex.length === 1
          ? `000${count}`
          : stringIndex.length === 2
          ? `00${count}`
          : stringIndex.length === 3
          ? `0${count}`
          : count; // 4 characters -> no need to add additional 0's in front of id.

      return {
        ...file,
        processedName: newFileName(file, newId),
        fileNameIdentifier: newId,
        processId: generateUuid(),
      };
    });

    if (newData.length > 0) setReadyForRender(true);
    setNewDataForOnSuccess(newData);
  }, [dataForOnSuccess, open]);

  return (
    <div>
      {open && (
        <Modal open={open} size="small">
          {data.list && data.list.length > 0 && (
            <>
              <Header icon>
                <Icon name={data.icon} />
                {t("assets_to_process")}:
              </Header>
              <Modal.Content className="process-modal">
                <ul className="file-name-identifier-instructions">
                  <li>{t("file_name_identifier_validation_1")}</li>
                  <li>{t("file_name_identifier_validation_2")}</li>
                  <li>{t("file_name_identifier_example")}</li>
                </ul>
                <List>
                  {newDataForOnSuccess.map((item, i) => (
                    <List.Item key={item.id + i}>
                      <List.Item>
                        <strong>{t("original_asset_name")}:</strong> {item.name}
                      </List.Item>
                      <List.Item className="name-identifier-field">
                        {!readyForRender ? (
                          <Loader active inline="centered" />
                        ) : (
                          <AddFileNameIdentifier
                            t={t}
                            i={i}
                            inputId={`input-identifier-${i + 1}`}
                            fileId={item.processId}
                            addFileNameIdentifier={addFileNameIdentifier}
                            newDataForOnSuccess={newDataForOnSuccess}
                          />
                        )}
                      </List.Item>
                      {/*<strong>{t("processed_asset_name")}:</strong>
                       <List as="ol" relaxed="very" className="processed-files-list">
                        {item.resolutions.nativeResolutions.map((item, r) => (
                          <ProcessedNameExamples
                            t={t}
                            key={r}
                            newDataForOnSuccess={newDataForOnSuccess}
                            item={item}
                            data={data}
                            i={i}
                          />
                        ))}
                      </List> */}
                      <Divider />
                    </List.Item>
                  ))}
                </List>
              </Modal.Content>
            </>
          )}
          {data.errorList && data.errorList.length > 0 && (
            <>
              <Header icon>
                <Icon name={data.icon} />
                {t("assets_to_process_error")}:
              </Header>
              <Modal.Content>
                <List>
                  {data.errorList.map((item) => (
                    <List.Item key={item.id}>
                      <List.Icon name="remove" color="red" />
                      {t("asset_name")}: {item.name}
                    </List.Item>
                  ))}
                </List>
              </Modal.Content>
            </>
          )}
          <Modal.Actions>
            <Button color="red" onClick={() => setOpen(false)}>
              <Icon name="remove" /> {t("modal_cancel")}
            </Button>
            <Button
              data-test="confirmmation_modal_confirm"
              color="green"
              disabled={data.list.length === 0 || !canSendForProcessing}
              onClick={() => {
                onSuccess(newDataForOnSuccess);
                setOpen(false);
              }}
            >
              <Icon name="checkmark" /> {t("modal_confirm")}
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </div>
  );
}

export default ProcessConfirmationModal;
